import { NumberField, NumberFieldProps } from "@justhome/react-ui";
import {
  Control,
  FieldPath,
  FieldValues,
  Path,
  PathValue,
  useController,
  UseControllerProps,
} from "react-hook-form";
import useLocale from "@lib/hooks/useLocale";

export interface NumberInputExtraProps<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  rules?: UseControllerProps<T>["rules"];
  defaultValue?: PathValue<T, Path<T>>;
  alwaysShowError?: boolean;
}

type NumberInputProps<T extends FieldValues> = NumberInputExtraProps<T> &
  Omit<NumberFieldProps, "ref">;

const NumberInput = <T extends FieldValues>({
  name,
  control,
  rules,
  defaultValue,
  alwaysShowError = false,
  ...props
}: NumberInputProps<T>) => {
  const {
    field,
    fieldState: { isTouched, invalid, error },
    formState: { isSubmitted },
  } = useController({ name, control, rules, defaultValue });
  const errorMessage = error?.message;
  const locale = useLocale();
  const isInvalid = (isTouched || isSubmitted) && invalid;
  return (
    <NumberField
      errorMessage={isInvalid || alwaysShowError ? errorMessage : undefined}
      germanLocale={["de", "immo"].includes(locale)}
      {...field}
      {...props}
    />
  );
};

export default NumberInput;
